import React from 'react'

import { Trans } from 'src/translations'
import { useIsIntlRestaurant } from 'src/lib/js/hooks/useIsIntlRestaurant'

export const ToastTOSAndPrivacy = () => {
  return (
    <>
      <Trans
        i18nKey='legal-utils.toast-tos-and-privacy'
        components={[
          <a
            key='0'
            href='https://pos.toasttab.com/terms-of-service/#diner-tos'
            rel='noopener noreferrer'
            target='_blank'
          />,
          <a
            key='1'
            href='https://pos.toasttab.com/privacy'
            rel='noopener noreferrer'
            target='_blank'
          />
        ]}
      />
    </>
  )
}
export const CAInfo = () => {
  return (
    <>
      <Trans
        i18nKey='legal-utils.ca-info'
        components={[
          <a
            key='0'
            href='https://pos.toasttab.com/privacy#addendum-a'
            rel='noopener noreferrer'
            target='_blank'
          />
        ]}
      />
    </>
  )
}

export const AccountCreationLegalDisclaimer = () => {
  const isIntlRx = useIsIntlRestaurant()

  if (isIntlRx) {
    return (
      <div>
        <Trans
          i18nKey='complete-profile-form.legal-text.intl'
          components={{
            ToastTOSAndPrivacy: <ToastTOSAndPrivacy />
          }}
        />
      </div>
    )
  }
  return (
    <div>
      <Trans
        i18nKey='complete-profile-form.legal-text.us'
        components={[
          <a
            key='0'
            href='https://pos.toasttab.com/terms-of-service/#diner-tos'
            rel='noopener noreferrer'
            target='_blank'
          />,
          <a
            key='1'
            href='https://pos.toasttab.com/privacy'
            rel='noopener noreferrer'
            target='_blank'
          />,
          <a
            key='2'
            href='https://pos.toasttab.com/privacy#addendum-a'
            rel='noopener noreferrer'
            target='_blank'
          />
        ]}
      />
    </div>
  )
}
